import * as employerService from '../../services/employer.service';


const state = {
    employerPaginate:{},
    employerPaginateData:{},
};

const getters = {
    getEmployerPaginate:state => (state.employerPaginate),
    getEmployerPaginateData:state => (state.employerPaginateData),
};

const actions = {
    async fetchEmployerPaginate({ commit }, obj){
        commit('setEmployerPaginate', obj)
        try {
            const response = await employerService.listPage(obj);
            commit('setEmployerPaginateData', response.data);
        } catch (error) {
            console.log('something wrong - fetchEmployerPaginate', error);
        }
    },
};

const mutations = {
    setEmployerPaginateData:(state, res) => (
        state.employerPaginateData =  res
    ),
    setEmployerPaginate:(state, res) => (
        state.employerPaginate =  res
    )
};

export default{
    state,
    getters,
    actions,
    mutations,
}
